import {
    GET_TOOL_RECIPES_LOADING,
    GET_TOOL_RECIPES_SUCCESS,
    GET_TOOL_RECIPES_FAILURE
} from '../actionTypes'
import store from '../store';
import { showUnknownError } from './keyboard-shortcuts.actions';
import { client } from '../../services/client';
import { getRecursivelyAsync } from '../../utils/get-recursively-async';

export const getToolRecipesSuccess = payload => ({
    type: GET_TOOL_RECIPES_SUCCESS,
    payload
})

export const getToolRecipesFailure = () => ({
    type: GET_TOOL_RECIPES_FAILURE
})

export const getToolRecipesAsync = payload => dispatch => {
    return dispatch(getRecursivelyAsync('tool-recipes', getToolRecipesSuccess, 0));
}